import PropTypes from 'prop-types';
import Label from 'infrastructure/js/components/Label/label.js';
import cn from 'classnames';

import './iconAndLabelCell.scss';


export default function IconAndLabelCell({
                                           value = { icon: null, label: '', className: '' },
                                         }) {
  const { icon: Icon, label = '', className = '' } = value ?? {};

  return (
    <div className={cn('icon-label-cell', className)}>
      {Icon && <Icon />}
      <Label text={label} />
    </div>
  );
}

IconAndLabelCell.propTypes = {
  value : PropTypes.shape({
    icon: PropTypes.any,
    label: PropTypes.string,
    className: PropTypes.string,
  })
};
